export default "__VITE_ASSET__808a4d63__"